module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "flex bg-white new-shadow-theme br3 custom-padding responsive-box"
  }, [_c('div', {
    staticClass: "flex flex-column w-100 responsive-plan"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/upsell/important.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cera-round-pro-medium f4 mb3 fw5 mt2"
  }, [_vm._v("Important")]), _vm._v(" "), _c('div', {
    staticClass: "inter mb1 f6 items-center justify-start text-container mb4"
  }, [_vm._v("\n      Complete your plan activation through one of the methods below\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "inter mb1 f6 items-center justify-start text-container mb4"
  }, [_vm._v("\n      Each of the other users you registered received their own SMS with a password and instructions.\n      Each user will need to login and activate their own account from their phone as a part of the verification process.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "inter mb1 f6 items-center justify-start text-container mb4"
  }, [_vm._v("\n      If you have any queries or need help completing registration, don't hesitate to reach out to us!\n    ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "tc flex justify-end"
  }, [_c('ak-button', {
    staticClass: "button-responsive mr3",
    attrs: {
      "newSecondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return null.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Read FAQs\n        ")]), _vm._v(" "), _c('ak-button', {
    staticClass: "button-responsive",
    attrs: {
      "newPrimary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showModal.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Email Us\n        ")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb4"
  }, [_c('ol', {
    staticClass: "inter f6 items-center justify-start text-container list-padding"
  }, [_c('li', {
    staticClass: "pl3 inter f6 items-center justify-start text-container"
  }, [_vm._v("\n          Follow the instructions in the SMS you just received to your phone.\n          Click the link and use your temporary password to login.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-center mv3"
  }, [_c('hr', {
    staticClass: "gray-hr center"
  }), _vm._v(" "), _c('div', [_vm._v("OR")]), _vm._v(" "), _c('hr', {
    staticClass: "gray-hr center"
  })]), _vm._v(" "), _c('li', {
    staticClass: "pl3 inter f6 items-center justify-start text-container"
  }, [_vm._v("\n          Scan the QR code shown below to download the application.\n          Later use the temporary password to login to account.\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex justify-center mb4"
  }, [_c('img', {
    staticClass: "qr",
    attrs: {
      "src": "/static/upsell/qr.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08d5a7b3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/upsell/FinishUpsell.vue
// module id = 1022
// module chunks = 0